import { render, staticRenderFns } from "./CustomerPointsTypeAdd.vue?vue&type=template&id=7b1a0851&scoped=true&"
import script from "./CustomerPointsTypeAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerPointsTypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPointsTypeAdd.vue?vue&type=style&index=0&id=7b1a0851&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a0851",
  null
  
)

export default component.exports